import { UserRejectsError } from "@tonconnect/sdk"

import { ApiError } from "@/shared/api"

const MAX_LEN = 200

export function analyticsErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return `${error.status}: ${error.message}`.slice(0, MAX_LEN)
  }
  if (error instanceof Error) {
    return error.message.slice(0, MAX_LEN)
  }
  return "unknown"
}

export type DepositFailureReason = "user_rejected" | "api_error" | "unknown"

export function classifyDepositFailure(error: unknown): DepositFailureReason {
  if (error instanceof UserRejectsError) return "user_rejected"
  if (error instanceof ApiError) return "api_error"
  if (error instanceof Error && /reject/i.test(error.message)) {
    return "user_rejected"
  }
  return "unknown"
}
